module.exports = __webpack_public_path__ + "img/search-nothing.3a21801f.png";